<script lang="ts">
    import Thermometer from "../../../public/icons/thermometer.svelte";
    import {
        conditions,
        cType,
        Observation,
        Widget,
        widgetInfo,
        WidgetType,
    } from "../../store";

    export let isPrimaryCondition: boolean = false;

    let fill = "--default-color";
    let errorFill = "--error-color";
    let chillFill = "--chill-color";
    let threshold = undefined;
    let secondaryThreshold = undefined;
    let conditionValue = 70;

    widgetInfo.subscribe((value: Widget) => {
        const currentConditions = value.widgetConditions;
        const feelCondition = currentConditions.find(
            (condition) => condition.conditionType === cType.FEEL,
        );
        if (value && value.widgetConditions) {
            if (value.type != WidgetType.DEF && isPrimaryCondition) {
                fill = "--primary-color";
            }
            if (isPrimaryCondition && value.policies) { // NPA
                threshold = value.primaryThreshold;
                secondaryThreshold = value.secondaryThreshold;
            } else {
                if (feelCondition) {
                    threshold = feelCondition.threshold;
                    secondaryThreshold = feelCondition.secondaryThreshold;
                }
            }
        }
    });

    conditions.subscribe((value: Observation) => {
        let temp = 70; //default temp value to widget has something to display without an org loc.
        if (value && value.feelLike) {
            const feelLike = value.feelLike.value;
            temp = Math.round(feelLike);
        }
        if (threshold != undefined && temp >= threshold) {
            fill = errorFill;
        }
        if (secondaryThreshold != undefined && temp <= secondaryThreshold) {
            fill = chillFill;
        }
        conditionValue = temp;
    });
</script>

<div class="cc-container" style="color: var({fill})">
    {#if !isPrimaryCondition}
        <div class="weatherIcon">
            <Thermometer fill="var({fill})" />
        </div>
    {/if}

    <div class={isPrimaryCondition ? "primary-value" : "value"}>
        {conditionValue}&deg;
    </div>

    <div class={isPrimaryCondition ? "primary-label" : "label"}>Feels</div>
</div>
